<template>
  <v-banner sticky ref="header" class="white ma-0 pa-0 sticky" elevation="0">
    <v-row justify="space-around">
      <v-col cols="12" sm="10" md="8">
        <v-sheet elevation="0" class="py-0 px-1 d-flex justify-center">
          <v-chip-group mandatory active-class="myBlue">
            <v-chip label link color="myGreen2" class="white--text pa-0">
              <v-container @click="FILTER_ITEMS('All')">
                All
              </v-container>
            </v-chip>
            <v-chip
              v-for="(category, id) in filtername"
              :key="id"
              label
              link
              color="myGreen"
              class="white--text pa-0"
            >
              <v-container
                @click="FILTER_ITEMS(category.id)"
                class="font-weight-bold text-body-1"
              >
                {{ category.name }}
              </v-container>
            </v-chip>
          </v-chip-group>
        </v-sheet>
      </v-col>
    </v-row>
  </v-banner>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { axios } from "../../api";

export default {
  data: () => ({
    filtername: null,
  }),
  computed: {
    ...mapGetters(["items"]),
  },
  methods: {
    ...mapActions(["FILTER_ITEMS"]),
  },
  mounted() {
    axios
      .get("/getCategory")
      .then((res) => {
        this.filtername = res.data;
      })
      .catch((err) => console.log(err));
  },
};
</script>
